import cookie from 'react-cookies'

const sessionToken = cookie.load('USER-SESSION')
const isToken = !!sessionToken
export const token = isToken ? sessionToken.token : ''




// WEBPACK FOOTER //
// ./src/utils/authToken.js